import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { API, Auth } from 'aws-amplify'
import {
  ExclamationTriangleIcon,
} from '@heroicons/react/20/solid'
import { ERRORS } from '../../config/app'
import Spin from '../../components/Spin'
import config from '../../config/aws';
import i18n from '../../i18n'
import NewPasswordForm from './NewPasswordForm'

const ForgotPassword = () => {
  const [loading, setLoading] = useState(false)
  const [email,setEmail] = useState("")
  const [errorMessage, setErrorMessage] = useState(null)
  const [showConfirmationBox, setShowConfirmationBox] = useState(false)

  const onSubmit = async (e) => {
    e.preventDefault()
    const [email] = e.target
    console.log(email.value)
    if (email.value) {
      setLoading(true)

      try {
        const params = {
          email : email.value,
          UserPoolId: config.cognito.USER_POOL_ID,
          ClientId : config.cognito.APP_CLIENT_ID
        };
        const res = await API.post('rcs-api', '/forgot-password', {
          body: params
        })
        setEmail(email.value)
        setShowConfirmationBox(true)
        setErrorMessage(null)
      } catch (err) {
        console.log(err)
        setErrorMessage(i18n.t('wrong_email'))
      }
      setLoading(false)
    } else {
      setErrorMessage(i18n.t('password_not_match'))
    }
  }

  return (
    <>
      <div className="min-h-full flex">
        <div className="flex-1 flex flex-col justify-center py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
          <div className="mx-auto w-full max-w-sm lg:w-96">
            <div>
              <img
                src="/assets/imgs/logo-tadoo-black.svg"
                style={{ width: '200px' }}
                alt="logo"
              />
              <h2 className="mt-6 text-3xl font-extrabold text-grey-blue">
                {i18n.t('reset_password')}
              </h2>
              <p className="mt-2 text-sm text-gray-600">
                {i18n.t('or')}{' '}
                <Link
                  to="/login"
                  className="font-medium text-blue-dark hover:text-blue-dark hover:underline"
                >
                  {i18n.t('log_in_register')}
                </Link>
              </p>
            </div>
            {!showConfirmationBox ? (
              <div className="mt-8">
                <div className="mt-6">
                  <form onSubmit={onSubmit} className="space-y-6">
                    <div>
                      <label
                        htmlFor="email"
                        className="block text-sm font-medium text-grey-blue"
                      >
                        Email
                      </label>
                      <div className="mt-1">
                        <input
                          id="email"
                          name="email"
                          type="email"
                          autoComplete="email"
                          required
                          className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        />
                      </div>
                    </div>
                    {errorMessage && (
                      <div className="rounded-md bg-yellow-50 p-4">
                        <div className="flex">
                          <div className="flex-shrink-0">
                            <ExclamationTriangleIcon
                              className="h-5 w-5 text-yellow-400"
                              aria-hidden="true"
                            />
                          </div>
                          <div className="ml-3">
                            <h3 className="text-sm font-medium text-yellow-800">
                              {i18n.t('atention')}
                            </h3>
                            <div className="mt-2 text-sm text-yellow-700">
                              <p>{errorMessage}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    <div>
                      <button
                        type="submit"
                        className="ease-in duration-100 w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        disabled=""
                      >
                        {loading && <Spin type="darkBg" size="small" />}
                        {loading ? i18n.t('processing') : i18n.t('send_email')}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            ) : (<NewPasswordForm email={email}/>)}
          </div>
        </div>
        <div className="hidden lg:block relative w-0 flex-1">
          <img
            className="absolute inset-0 h-full w-full object-cover"
            src="/assets/imgs/img-bg-chatsales.jpg"
            alt=""
          />
        </div>
      </div>
    </>
  )
}

export default ForgotPassword
